import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectCurrentLessonTaskStepKey } from './current-lesson-task-step-key.selector.ts';
import { selectIsGodMode } from './is-god-mode.selector.ts';
import { selectLastCompletedLesson } from './last-completed-lesson.selector.ts';

export const selectIsUsingTempTracking = createMemoizedSelector(
  selectIsGodMode,
  selectCurrentLessonTaskStepKey,
  selectLastCompletedLesson,
  (isGodMode, currentLessonTaskStepKey, lastCompletedLesson): boolean => {
    if (isGodMode) {
      // God mode is always using temp tracking
      return true;
    }

    // If the last completed lesson is greater than the current lesson, then we are repeating a lesson
    return lastCompletedLesson >= currentLessonTaskStepKey?.lesson;
  }
);
